
import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import {MenuItem} from "@/features/applications/components/NavApplication.vue";
import {RequirementFulfillmentStatus} from "@/api-client";
import {ls} from "@/CultureService";

@Component
export default class NavApplicationMenuItem extends Vue {
    @Prop({required: true})
    item!: MenuItem;

    @Prop({ default: () => null })
    getIcon!: ((status: RequirementFulfillmentStatus) => string) | null;

    getDescription(status: RequirementFulfillmentStatus): string {
        switch (status) {
            case RequirementFulfillmentStatus.Unfulfilled:
                return ls.Applications_Nav_RequirementFulfillmentStatus_Unfulfilled;
            case RequirementFulfillmentStatus.Fulfilled:
                return ls.Applications_Nav_RequirementFulfillmentStatus_Fulfilled;
            case RequirementFulfillmentStatus.FulfilledAutomatically:
                return ls.Applications_Nav_RequirementFulfillmentStatus_FulfilledAutomatically
            case RequirementFulfillmentStatus.Accepted:
                return ls.Applications_Nav_RequirementFulfillmentStatus_Accepted
            case RequirementFulfillmentStatus.Rejected:
                return ls.Applications_Nav_RequirementFulfillmentStatus_Rejected
        }
        return "";
    }
}
